import { getUrlSearchParams } from "@func-core/core/utils/browser-features";

export type UrlParamsAdapter = {
  getUtmCampaign: () => string | null;
  getNoEditable: () => boolean;
};

export function createBrowserUrlParamsAdapter(window: Window): UrlParamsAdapter {
  const searchParams = getUrlSearchParams(window);

  return {
    getUtmCampaign: () => searchParams?.get("utm_campaign") ?? null,
    getNoEditable: () => searchParams?.get("no_editable") === "1",
  };
}
